import {useQuery} from '@tanstack/react-query';
import {featureApi} from '../../services/api-services';

/**
 * Handles calling of the features api. Share across all features.
 */
export const useFeaturesQuery = () => {
    return useQuery({
        queryKey: ['features'],
        queryFn: featureApi,
        staleTime: TEN_MINUTES_IN_MILLIS,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });
};
const TEN_MINUTES_IN_MILLIS = 600_000;

/**
 * Basic Json structure that all features should adhere to.
 * Features can extend this for their own fields.
 */
export interface BaseFeatureFields {
    /**
     * When the feature begins.
     * @example "2023-04-15T14:30:00Z"
     */
    readonly startDateTime: string;
    /**
     * When the feature ends. If there is no end(`null`), assume it continues forever.
     * @example "2023-04-15T14:30:00Z"
     * @example null
     */
    readonly endDateTime?: string;
}

